import { action, makeObservable, observable } from 'mobx';
import type { ISplineDetails } from '../interfaces';
import { SplineItems } from '../interfaces';

export class SplineDetails implements ISplineDetails {
  @observable public highlightedSplineItem: SplineItems;

  public constructor(highlightedItem: SplineItems = SplineItems.None) {
    this.highlightedSplineItem = highlightedItem;
    makeObservable(this);
  }

  @action
  public setHighlightedSplineItem(item: SplineItems): void {
    this.highlightedSplineItem = item;
  }
}
